























































































import { Component, Vue } from 'vue-property-decorator';
import { ApiKeyApi } from '../api/apiKey';
import { ApiKeyVm } from '../classes/apiKeyVm';
import AppMessage from 'modules/core/models/appMessage';
import { ElTable } from 'element-ui/types/table';
import environment from '@/environment';
import dayjs from 'dayjs';
import store from '@/store/index';

@Component
export default class List extends Vue {
  public tableColumns: any[] = [];
  public tableData: ApiKeyVm[] = [];
  public loading: boolean = false;
  public generatedApiKey: string = '';
  public dialogVisible: boolean = false;
  public apiDocumentationLink = environment.apiDocumentationLink;
  public masterAccountId: string;
  private api: ApiKeyApi;

  constructor() {
    super();
    this.api = new ApiKeyApi();

    this.masterAccountId = store.state.auth && store.state.auth.user
    ? store.state.auth.user.MasterAccountId
    : null;
  }

  public async created() {
    this.tableColumns = [
      {
        prop: 'apiKey',
        label: this.$t('apiKeys.apiKey'),
        sortable: true,
      },
      {
        prop: 'created',
        label: this.$t('apiKeys.created'),
        sortable: true,
      },
    ];

    this.refresh();
  }

  public async refresh() {
    this.loading = true;
    this.tableData = await this.api.list();
    this.loading = false;
  }

  public async add() {
    this.loading = true;
    try {
      this.generatedApiKey = await this.api.add();
      this.refresh();
      this.dialogVisible = true;
    } catch (error) {
      console.error(error);
    }
    this.loading = false;
  }

  public formatDate(date: Date) {
    return dayjs(date).format('DD-MM-YYYY');
  }

  public deleteKey(keyId: string) {
    this.$confirm(
      this.$t('apiKeys.deleteText') as string,
      this.$t('apiKeys.deleteTitle', { keyId }) as string,
      {
        confirmButtonText: this.$t('general.yes') as string,
        cancelButtonText: this.$t('general.no') as string,
        type: 'warning',
      },
    )
      .then(async () => {
        const result: boolean = await this.api.delete(keyId);
        if (result) {
          this.tableData = this.tableData.filter((item: ApiKeyVm) => {
            return item.id !== keyId;
          });

          AppMessage.show(this.$t('apiKeys.deleteSuccess'), 'success');
        }
      });
  }
}
